export var isOldNotificationAPI = function isOldNotificationAPI(notification) {
  return notification.action !== undefined;
};